import type {FinishedActionResponse, IdentifiedFile, Rec, UUID} from 'src/typings';
import type {AjaxService} from 'core/data-services/ajax.service';
import {ngAsync} from 'shared/utils/ng-@decorators';
import {transferify} from 'shared/utils/data-service-utils';

interface SetFileAsPrimaryCoverParams {
    record: Rec;
    file: IdentifiedFile;
}

interface UploadNewCoverImageParams {
    record: UUID;
    fileData: File;
}

export class RecordCoverDataService {
    public static serviceName = 'recordCoverDataService';

    public static readonly SET_COVER_ROUTE = 'records/covers/primary/set';
    public static readonly UPLOAD_NEW_COVER_IMAGE_ROUTE = 'records/covers/add';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    @ngAsync()
    public async setFileAsPrimaryCover(params: SetFileAsPrimaryCoverParams): Promise<FinishedActionResponse> {
        return this.ajaxService
            .createRequest(`${RecordCoverDataService.SET_COVER_ROUTE}`)
            .post(transferify(params));
    }

    @ngAsync()
    public async uploadNewCoverImage(params: UploadNewCoverImageParams): Promise<FinishedActionResponse> {
        const formData = new FormData();
        formData.append('record', params.record);
        formData.append('fileData', params.fileData);

        return this.ajaxService
            .createRequest(`${RecordCoverDataService.UPLOAD_NEW_COVER_IMAGE_ROUTE}`)
            .postMultipart(formData);
    }
}